// extracted by mini-css-extract-plugin
export default {"root":"r4hzv"};